// Podcast list — post-processes the /podcast/ episode archive:
//
// 1. Injects a year rule before each row whose data-year differs
//    from the previous row's (Handlebars can't detect a year change
//    mid-iteration, so we do it here).
// 2. Swaps the count placeholder with the real number of episodes.
// 3. Shows the empty-state line when there are no episodes yet.

export default function podcastList() {
    const stream = document.querySelector("[data-pod-stream]");
    if (!stream) return;

    const rows = stream.querySelectorAll(".gg-pod__row");
    const countEl = document.querySelector("[data-pod-count]");
    const emptyEl = document.querySelector("[data-pod-empty]");

    // Empty state
    if (!rows.length) {
        if (emptyEl) emptyEl.removeAttribute("hidden");
        return;
    }

    // Year rules
    let lastYear = null;
    rows.forEach((row) => {
        const year = row.dataset.year;
        if (!year || year === lastYear) return;

        const divider = document.createElement("div");
        divider.className = "gg-pod__year";
        divider.innerHTML =
            `<span class="gg-pod__year-y">${year}</span>` +
            `<span class="gg-pod__year-rule"></span>`;
        stream.insertBefore(divider, row);
        lastYear = year;
    });

    // Count
    if (countEl) countEl.textContent = `${rows.length} · ongoing`;
}
